declare const hj: any;


export namespace Hotjar {

  export const init = (): Promise<boolean> => {
    return new Promise<boolean>((resolve, reject) => {
      try {
        if (document.getElementById('hotjar')) { 
          resolve(true);
          return; 
        }

        const id = process.env.HOTJAR_ID;
        (function(h: any, o: Document, t: string, j: string){
          h.hj = h.hj || function() {(h.hj.q = h.hj.q || []).push(arguments)};
          h._hjSettings = {hjid: id, hjsv: 6};
          const a = o.getElementsByTagName('head')[0];
          const r = o.createElement('script');
          r.id = 'hotjar';
          r.async = true;
          r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
          r.onload = () => resolve(true);
          r.onerror = (e) => reject(e);
          a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  };
  
  export const identify = async (userId: string, args?: any) => {
    try {
      // await Hotjar.init();
      hj('identify', userId, args);
    } catch (e) {
      console.error(e);
    }
  };

}